export function trackAction(name, image, locale) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    seo_id: image?.seoId,
    category: image?.tag,
    language: locale,
    // Never send search input, file paths or user-entered data.
    transport_type: 'beacon',
  });
}
